import React from 'react';
import { Link, useInRouterContext } from 'react-router-dom';
import { linkifyText } from '../../utils/linkify';

/** Interne dartcloudapp.de-Links (22.10.2026): Pfad für react-router, sonst null (extern, Mail, Anker). */
export function internalPathFromHref(href: string | null | undefined): string | null {
  const raw = String(href ?? '').trim();
  const m = raw.match(/^https?:\/\/(?:www\.)?dartcloudapp\.de(\/[^\s]*)?$/i);
  if (!m) return null;
  const p = m[1] || '/';
  return p.startsWith('/') ? p : `/${p}`;
}

const LINK_CLASS = 'text-[#3fced1] underline decoration-[#3fced1]/50 hover:decoration-[#3fced1] break-all';

/**
 * Text mit klickbaren Links (Marcel 2026-09-20, überall 22.10.2026): externe Links öffnen in neuem Tab,
 * interne dartcloudapp.de-Links bleiben in der App (react-router, gleicher Tab); der Klick blubbert nicht
 * zur Karte hoch (kein Sprung in die Detailseite). Zeilenumbrüche behält der umgebende Container (whitespace-pre-*).
 */
const LinkifiedText: React.FC<{ text: string | null | undefined; className?: string }> = ({ text, className }) => {
  const inRouter = useInRouterContext();
  const segments = linkifyText(text ?? '');
  return (
    <>
      {segments.map((s, i) => {
        if (s.type !== 'link') return <React.Fragment key={i}>{s.value}</React.Fragment>;
        const internal = internalPathFromHref(s.href);
        if (internal && inRouter) {
          return (
            <Link key={i} to={internal} onClick={(e) => e.stopPropagation()} className={className ?? LINK_CLASS} data-testid="linkified-internal">
              {s.value}
            </Link>
          );
        }
        return (
          <a key={i} href={s.href} target="_blank" rel="noopener noreferrer nofollow" onClick={(e) => e.stopPropagation()} className={className ?? LINK_CLASS} data-testid="linkified-external">
            {s.value}
          </a>
        );
      })}
    </>
  );
};

export default LinkifiedText;
